// extracted by mini-css-extract-plugin
export default {"wrapper":"sMVyi2HcqGDCuZjEa6Ak","input":"Rcp2WQAydhxk6KU1omFl","text":"cRy268QLzgjm3LgU4cHQ"};